import { prefixNumber } from "./utils";

export const formatToPhone = (val: string) => {
    const value = val.replace(/\D+/g, "");
    const numberLength = 11;

    let result;
    if (val.includes("+8") || val[0] === "8") {
        result = "";
    } else {
        result = "+";
    }

    for (let i = 0; i < value.length && i < numberLength; i++) {
        switch (i) {
            case 0:
                result += prefixNumber(value[i]);
                continue;
            case 4:
                result += ") ";
                break;
            case 7:
                result += "-";
                break;
            case 9:
                result += "-";
                break;
            default:
                break;
        }
        result += value[i];
    }
    return result;
};

export const renderPrice = (val: number) => {
    return `${numberWithSpaces(val)} ₽`;
};

export const printNumber = (value: number | null | undefined) => {
    if (value === null || value === undefined) {
        return "";
    } else if (value === 0) {
        return "0";
    } else {
        return numberWithSpaces(value);
    }
};

export const numberWithSpaces = (x: string | number, returnZero = false) => {
    if (!x) {
        return "";
    }
    const res = x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    if (res === "0" && returnZero) return "";
    if (res === "0" && !returnZero) return "0";
    return res;
};